export default __webpack_public_path__ + "static/media/servicosp2.467b4079.jpg";